// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"fb536b99","638":"8b6c1782","843":"68c55a4f"}[chunkId] + ".chunk.js";
};